module.exports = __webpack_public_path__ + "static/focus-0a9fb20af2289c75c9b8020144a7032e.png";